// VietQR api
import axiosClient from './axiosClient'

export const thirdPartyApi = {
  vietQR: {
    verifyToken: (params) => {
      const url = '/vietQR/verify-token'
      return axiosClient.post(url, { ...params })
    },
  },
}
